const arborealLinseStatuses = ['production', 'mechanical issues FJ', 'mechanical issues GLT', 'mechanical issues CLT', 'open doors FJ', 'open doors GLT', 'open doors CLT'];

export default arborealLinseStatuses;
